import isMobileBrowser from '../utils/isMobileBrowser';
import { DESKTOP_VISIBLE_BTN_COUNT, MOBILE_VISIBLE_BTN_COUNT, SELECTORS } from './constants';
import { generatePageRange } from './helpers';
import { PaginationUI } from './ui';

export class PaginationHandler {
  constructor(onChangePage) {
    this.visibleBtnCount = 9;
    this.paginationUI = new PaginationUI();
    this.onChangePage = onChangePage;
  }

  nextPage = () => this.onChangePage(this.currentPage + 1);

  prevPage = () => this.onChangePage(this.currentPage - 1);

  getFirstVisiblePage = (totalPages, visibleBtnCount) => {
    const minStartPage = 1;
    const maxStartPage = totalPages - visibleBtnCount + 1;
    const calculatedStartPage = this.currentPage - Math.floor(visibleBtnCount / 2);

    return Math.max(minStartPage, Math.min(maxStartPage, calculatedStartPage));
  };

  getLastVisiblePage = (startPage, totalPages, visibleBtnCount) => (
    Math.min(startPage + visibleBtnCount - 1, totalPages)
  );

  render = (count, currentPage, totalPages) => {
    if (count > 0) {
      this.currentPage = currentPage;

      const visibleBtnCount = isMobileBrowser()
        ? MOBILE_VISIBLE_BTN_COUNT
        : DESKTOP_VISIBLE_BTN_COUNT;

      const startPage = this.getFirstVisiblePage(totalPages, visibleBtnCount);
      const lastPage = this.getLastVisiblePage(startPage, totalPages, visibleBtnCount);
      const pageRange = generatePageRange(startPage, lastPage);

      this.paginationUI.render();
      this.paginationUI.updateButton(SELECTORS.PREV_BTN, this.currentPage === 1, this.prevPage);
      this.paginationUI.renderPageButtons(pageRange, this.currentPage, this.onChangePage);
      this.paginationUI.updateButton(SELECTORS.NEXT_BTN, this.currentPage === totalPages, this.nextPage);
    } else {
      this.paginationUI.hidePagination();
    }
  };
}
